export default __webpack_public_path__ + "images/R3.56b79e4.png";